// Mail slots — mirrors AveOrga.Domain.Entities.MailSlots (group-dependent mail kinds). The full catalog
// incl. placeholders comes from GET /Textblock/Slots; these labels cover places that only need a name
// (inbox "Bei Annahme", hourglass tooltips) without an extra request.
export const ADD_ON_WAITLIST_SLOT = 'equipment_waitlist';

export const MAIL_SLOT_LABEL = {
  received: 'Anmeldung eingegangen',
  confirmed: 'Anmeldung bestätigt',
  waitlist: 'Warteliste',
  // Key stays "equipment_waitlist" (stored in mail rules / sent mails): add-on waitlist, {Zusatz} = exhausted add-ons.
  equipment_waitlist: 'Zusatz-Warteliste',
  cancelled: 'Abmeldung bestätigt',
  spot_available: 'Platz frei geworden',
  reminder: 'Erinnerung vor dem Termin',
  event_cancelled: 'Termin abgesagt',
  payment_request: 'Zahlungsaufforderung',
  payment_confirmed: 'Zahlungsbestätigung',
  announcement: 'Ankündigung (Prozess-Mail)',
  welcome: 'Willkommen in der Gruppe',
};

export const mailSlotLabel = (slot) => MAIL_SLOT_LABEL[slot] ?? slot ?? '';
